import axios from "axios";
import { GetCancellationProposalResponse } from "../types/Cancellation";

export const getCancellationProposal = async (
  offerUuid: string
): Promise<GetCancellationProposalResponse> => {
  try {
    const { data } = await axios.get<GetCancellationProposalResponse>(
      `${process.env.REACT_APP_API}/landing-page-proxy/api/cancelation-proposal/${offerUuid}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const confirmCancellationProposal = async (offerUuid: string) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API}/landing-page-proxy/api/cancelation-proposal/${offerUuid}`
    );
  } catch (error) {
    throw error;
  }
};
